import ACTIONS from 'constants/actionTypes';
import ActionReducer from 'types/ActionReducer';

const initialState = {
  isAuthorized: false,
};

const localization = (state = initialState, action: ActionReducer) => {
  const { type, payload } = action;

  switch (type) {
    case ACTIONS.CHECK_LOCALIZATION_ROLE:
      return {
        ...state,
        isAuthorized: payload.isAuthorized,
      };
    default:
      return state;
  }
};

export default localization;
